{
  "dashboard": {
    "title": "Munkakörnyezetem",
    "subtitle": "Személyes hozzájárulásod a vállalatnál – folyamatok, ráfordítás, rendszerek és hálózat.",

    "stats": {
      "activeProcesses": "Aktív folyamatok",
      "activeProcessesDesc_one": "Részvétel",
      "activeProcessesDesc_other": "Részvételek",
      "totalActivities_one": "Tevékenység a folyamatokban",
      "totalActivities_other": "Tevékenységek a folyamatokban",
      "usedSystems": "Használt rendszerek",
      "usedSystemsDesc_one": "Rendszer",
      "usedSystemsDesc_other": "Rendszerek",
      "networkInteractions": "Hálózat",
      "networkDesc_one": "Személy",
      "networkDesc_other": "Személyek",
      "direct": "Közvetlen",
      "indirect": "Közvetett"
    },
    "capacity": {
      "title": "Kapacitáselosztás",
      "subtitle": "Ráfordítás folyamatonként (óra/hónap)"
    },
    "processes": {
      "title": "Folyamatok és tevékenységek",
      "activities_one": "{{count}} tevékenység",
      "activities_other": "{{count}} tevékenység",
      "noProcesses": "Még nincsenek folyamatok"
    },
    "activities": {
      "unnamed": "{{type}} (folyamatban)"
    },
    "systems": {
      "title": "Rendszereim",
      "processCount_one": "{{count}} Folyamat",
      "processCount_other": "{{count}} Folyamat",
      "noSystems": "Még nincsenek rendszerek"
    },
    "coWorkers": {
      "title": "Hálózatom",
      "all": "Összes",
      "direct": "Közvetlen",
      "upstream": "Felsőbb",
      "downstream": "Alsóbb",
      "noCoWorkers": "Nem találhatók munkatársak",
      "noCoWorkersDirect": "Nem találhatók közvetlen munkatársak",
      "noCoWorkersUpstream": "Nem találhatók upstream munkatársak",
      "noCoWorkersDownstream": "Nem találhatók downstream munkatársak"
    },
    "hoursSuffix": "{{value}} ó"
  }
}
